/* eslint-disable no-undef */
import firebase from '../fb'
import db from '../db'
import rtdb from '../rtdb'
import { firestoreAction } from 'vuexfire'
import axios from 'axios';

const state = {
  btccfa_buyOrders: [],
  btccfa_sellOrders: [],
  ethcfa_buyOrders: [],
  ethcfa_sellOrders: [],
  btcghs_buyOrders: [],
  btcghs_sellOrders: [],
  pmcfa_buyOrders: [],
  pmcfa_sellOrders: [],
  usdtcfa_sellOrders:[],
  usdtcfa_buyOrders:[]

};
const getters = {
  btccfa_buyOrders: state => {
    return state.btccfa_buyOrders
  },
  btccfa_sellOrders: state => {
    return state.btccfa_sellOrders
  },
  ethcfa_buyOrders: state => {
    return state.ethcfa_buyOrders
  },
  ethcfa_sellOrders: state => {
    return state.ethcfa_sellOrders
  },
  btcghs_buyOrders: state => {
    return state.btcghs_buyOrders
  },
  btcghs_sellOrders: state => {
    return state.btcghs_sellOrders
  },
  pmcfa_sellOrders: state => {
    return state.pmcfa_sellOrders
  },
  pmcfa_buyOrders: state => {
    return state.pmcfa_buyOrders
  },

  usdtcfa_sellOrders: state => {
    return state.usdtcfa_sellOrders
  },
  usdtcfa_buyOrders: state => {
    return state.usdtcfa_buyOrders
  },

  mybtccfaBids: state => {
    var user = firebase.auth().currentUser;
    return state.btccfa_buyOrders.filter(mybid => mybid.user_id === user.uid)
  },
  mybtccfaAsks: state => {
    var user = firebase.auth().currentUser;
    return state.btccfa_sellOrders.filter(myAsk => myAsk.user_id === user.uid)
  },
  mybtcghsBids: state => {
    var user = firebase.auth().currentUser;
    return state.btcghs_buyOrders.filter(mybid => mybid.user_id === user.uid)
  },
  mybtcghsAsks: state => {
    var user = firebase.auth().currentUser;
    return state.btcghs_sellOrders.filter(myAsk => myAsk.user_id === user.uid)
  },
  myethcfaBids: state => {
    var user = firebase.auth().currentUser;
    return state.ethcfa_buyOrders.filter(mybid => mybid.user_id === user.uid)
  },
  myethcfaAsks: state => {
    var user = firebase.auth().currentUser;
    return state.ethcfa_sellOrders.filter(myAsk => myAsk.user_id === user.uid)
  },
  mypmcfaBids: state => {
    var user = firebase.auth().currentUser;
    return state.pmcfa_buyOrders.filter(mybid => mybid.user_id === user.uid)
  },
  mypmcfaAsks: state => {
    var user = firebase.auth().currentUser;
    return state.pmcfa_sellOrders.filter(myAsk => myAsk.user_id === user.uid)
  },

  myusdtcfaBids: state => {
    var user = firebase.auth().currentUser;
    return state.usdtcfa_buyOrders.filter(mybid => mybid.user_id === user.uid)
  },
  myusdtcfaAsks: state => {
    var user = firebase.auth().currentUser;
    return state.usdtcfa_sellOrders.filter(myAsk => myAsk.user_id === user.uid)
  },
};
const mutations = {

  async exchanged(state, payload) {
    let user = firebase.auth().currentUser;
    let result = rtdb.ref(`${payload.asset}/${payload.currency}${payload.second}/exchanged`)
    let id=result.push().key
    let total = payload.type == 'achat' ? payload.bidTotal : payload.askTotal
    let exchanged = {
      id: id,
      type: payload.type,
      price: payload.price,
      amount: payload.amount,
      bidTotal: payload.bidTotal,
      askTotal: payload.askTotal,
      total: total,
      asset: payload.asset,
      currency: payload.currency,
      second: payload.second,
      created_at:firebase.database.ServerValue.TIMESTAMP,
      user_id: user.uid,
      maker: payload.maker,
      taker: payload.taker,
    }
    result.child(id).set(exchanged).then(()=>{
      console.log('exchanged added successfully');
    }).catch((err) => {
      console.log(err);
    })
  },

async commission(state, payload) {
    console.log(payload);
    let user = firebase.auth().currentUser;
    let commiss = Number(payload.commission)
    const add_bonus=async (user_id,bonus)=>{
      let userRef = db.collection('users').doc(user_id)
          let user_doc = await userRef.get()
          let sponsor=user_doc.data().sponsor
          console.log(sponsor , 'sponsor');

          if (sponsor.length < 10) {
            console.log('pas de sponsor');
            dispatch_commission(bonus)
            return
          }
      try {
        await db.runTransaction(async (tx) => {
            let sponsor_ref = db.collection('users').doc(sponsor)
            let sponsor_doc = await tx.get(sponsor_ref)
            console.log(sponsor_doc);
            if (sponsor_doc.exists) {
              let referal_bonus =firebase.firestore.FieldValue.increment(bonus*commiss)
              tx.update(sponsor_ref, {bonus: referal_bonus, totalBonus: referal_bonus})
            }else{
              dispatch_commission(bonus)
            }
        });
        console.log('Transaction success!');
        console.log('referal bonus added');
      } catch (e) {
        console.log('Transaction failure:', e);
      }
    }

    const dispatch_commission=(commission)=>{
      const increment = firebase.firestore.FieldValue.increment(commission * commiss);
      const storyRef = db.collection('perso').doc('sq0uDLaLRWWmdJd3srxk');
      storyRef.update({ commission: increment }).then(()=>{
        console.log('added', commission * commiss, 'to main commission');
      });
    }

    const partner_commission=(partner_id, share)=>{
      const increase = firebase.firestore.FieldValue.increment(share * commiss);
      const partnRef = db.collection('users').doc(partner_id);
      partnRef.update({ partn_cfa: increase, total_partn: increase}).then(()=>{
        console.log('added', share * commiss, 'to', partner_id);
      });
    }

    const parnters_list = [
      {id:'UZbqXC2gpEfRI22FzTzKpjAqsNg1', share: 0.1},
      //{id:'PyrcmKkU5fN9BF8QahW9Okmolq22', share: 0.01},
      //{id:'EzJlh3stsUhdLeOVNqm7DniYLsB2', share: 0.01},
      {id:'GnpWgeG0fIgIDxjvwYGKPllWQw72', share: 0.02}
    ]
    
    let remain_share = parnters_list.reduce((n, {share}) => n + share, 0)
    let referal_share = 0.05
    let commission_share = 1-(2*referal_share + remain_share)

    const partners_shares_commissions = (array) => {
      for (let i = 0; i < array.length; i++) {
        const partner = array[i];
        if (payload.maker !== partner.id && payload.taker!== partner.id ){
          partner_commission(partner.id , partner.share)
        }else{
        dispatch_commission(partner.share)
        }
      }
    }

    if (user.uid !== 'GdpDkMaABtPYy2NUdfq5ahT2IUt1') {
      dispatch_commission(commission_share)
      add_bonus(payload.maker,referal_share);
      add_bonus(payload.taker,referal_share);
      //parters commission_data
      partners_shares_commissions(parnters_list)
    }else{
      add_bonus(payload.maker,referal_share);
    }
  },
};

const actions = {
  bind_btccfa_buyOrders: firestoreAction(context => {
    // return the promise returned by `bindFirestoreRef`
    return context.bindFirestoreRef('btccfa_buyOrders', db.collection('crypto').doc('btccfa').collection('buyOrders').orderBy('bidPrice', 'desc'))
  })
  ,
  bind_btccfa_sellOrders: firestoreAction(context => {
    // return the promise returned by `bindFirestoreRef`
    return context.bindFirestoreRef('btccfa_sellOrders', db.collection('crypto').doc('btccfa').collection('sellOrders').orderBy('askPrice', 'asc'))
  }),
  bind_btcghs_buyOrders: firestoreAction(context => {
    // return the promise returned by `bindFirestoreRef`
    return context.bindFirestoreRef('btcghs_buyOrders', db.collection('crypto').doc('btcghs').collection('buyOrders').orderBy('bidPrice', 'desc'))
  }),
  bind_btcghs_sellOrders: firestoreAction(context => {
    // return the promise returned by `bindFirestoreRef`
    return context.bindFirestoreRef('btcghs_sellOrders', db.collection('crypto').doc('btcghs').collection('sellOrders').orderBy('askPrice', 'asc'))
  }),

  bind_ethcfa_buyOrders: firestoreAction(context => {
    // return the promise returned by `bindFirestoreRef`
    return context.bindFirestoreRef('ethcfa_buyOrders', db.collection('crypto').doc('ethcfa').collection('buyOrders').orderBy('bidPrice', 'desc'))
  }),

  bind_ethcfa_sellOrders: firestoreAction(context => {
    // return the promise returned by `bindFirestoreRef`
    return context.bindFirestoreRef('ethcfa_sellOrders', db.collection('crypto').doc('ethcfa').collection('sellOrders').orderBy('askPrice', 'asc'))
  }),
  bind_pmcfa_buyOrders: firestoreAction(context => {
    // return the promise returned by `bindFirestoreRef`
    return context.bindFirestoreRef('pmcfa_buyOrders', db.collection('electronic').doc('pmcfa').collection('buyOrders').orderBy('bidPrice', 'desc'))
  }),
  bind_pmcfa_sellOrders: firestoreAction(context => {
    // return the promise returned by `bindFirestoreRef`
    return context.bindFirestoreRef('pmcfa_sellOrders', db.collection('electronic').doc('pmcfa').collection('sellOrders').orderBy('askPrice', 'asc'))
  }),

  

  bind_usdtcfa_buyOrders: firestoreAction(context => {
    console.log('bind_usdtcfa_buyOrders');
    // return the promise returned by `bindFirestoreRef`
    return context.bindFirestoreRef('usdtcfa_buyOrders', db.collection('electronic').doc('usdtcfa').collection('buyOrders').orderBy('bidPrice', 'desc'))
  }),
  bind_usdtcfa_sellOrders: firestoreAction(context => {
    // return the promise returned by `bindFirestoreRef`
    return context.bindFirestoreRef('usdtcfa_sellOrders', db.collection('electronic').doc('usdtcfa').collection('sellOrders').orderBy('askPrice', 'asc'))
  }),

  bid({ commit }, payload) {
    
    if (payload.bidTotal > 0 && payload.bidPrice > 0 && payload.bidAmount > 0) {
      if (payload.bidTotal === (1 + payload.fee) * payload.bidAmount * payload.bidPrice) {
        let user = firebase.auth().currentUser;
        payload.user_id = user.uid;
        let url = payload.base_url + '/payment/bid'
        console.log(url);
        console.log(payload);
        let auth_token = payload.auth_token
        axios.post (url, payload,auth_token).then(result =>{
          console.log(result.data);
        }).catch(e =>{
          console.log(e);
        })
      } else {
        swal("Soucis avec l'ordre !!!", "les valeurs ne correspondent pas!", "error", {
          button: "ok"
        });
      }
    } else {
      swal("Non Non Non !!!", "Pas de valeur négative ici!", "error", {
        button: "pardon!"
      });
    }
  },



  ask({ commit }, payload) {

    if (payload.askTotal > 0 && payload.askPrice > 0 && payload.askAmount > 0) {
      if (payload.askTotal === (1 - payload.fee) * payload.askPrice * payload.askAmount) {
        let user = firebase.auth().currentUser;
        console.log(user);
        payload.user_id = user.uid;
        let url = payload.base_url + '/payment/ask'
        let auth_token = payload.auth_token
        axios.post (url, payload,auth_token).then(result =>{
          console.log(result.data);
        }).catch(e =>{
          console.log(e);
        })
      } else {
        swal("Soucis avec l'ordre !!!", "les valeurs ne correspondent pas!", "error", {
          button: "ok"
        });
      }

    } else {
      swal("Non Non Non !!!", "Pas de valeur négative ici!", "error", {
        button: "pardon!"
      });
    }

  },



  instant_commission({ commit }, payload) {
    commit('commission', payload)
  },


};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}





